<section class="centered-with-padding pb-14">
  @if (data.title; as title) {
    <h1 class="title-h1">{{ title }}</h1>
  }
  <div class="grid grid-cols-[1fr_auto] items-center gap-x-10 py-5 desk:py-2.5">
    <div>
      {{ "COMPONENT.CONTENU-ARTICLE.READING_TIME_LABEL" | translate }}
      <span class="font-bold">
        {{
          "COMPONENT.CONTENU-ARTICLE.MINUTE"
            | translatePlural: "MINUTES" : data.readingTimeMinutes ?? realReadingTimeMinutes()
        }}
      </span>
    </div>

    <div
      (click)="openSharePopup()"
      class="drop-shadow-custom cursor-pointer rounded-xl bg-anis p-1.5 active:translate-x-0.5 active:translate-y-0.5 active:drop-shadow-none">
      <app-svg [height]="24" [width]="24" src="assets/icons/share.svg" />
    </div>
  </div>
  @if (data.description; as description) {
    <div class="font-bold">{{ description }}</div>
  }
  @for (section of data.sections; track $index) {
    @if (section.type === "section_image") {
      @if (section.image; as image) {
        <div class="my-5 flex flex-col gap-y-0.5">
          <div class="h-[247px] overflow-hidden rounded-[20px] desk:h-[459px]">
            <app-image [image]="image" [isPriority]="!isImageInPreviousBlocks && $index === 0" />
          </div>
          @if (section.legend; as legend) {
            <div class="text-[10px]">{{ legend }}</div>
          }
        </div>
      }
    }
    @if (section.type === "section_html") {
      @if (section.title) {
        <h2 class="my-5 text-[22px] font-bold">{{ section.title }}</h2>
      }

      <div [innerHTML]="section.text" class="prose prose-no-quotes max-w-none" handleHtmlLinks></div>
    }
  }
</section>
